module.exports = __webpack_public_path__ + "img/logo.6dd84c52.png";